import type { DailyTask } from '../../../lib/dailyApi';
import { getProjectName } from '../../../utils/taskGrouping';
import { dailyTaskRow, TaskListRow, type TaskListRowTone } from '../../tasks/TaskListRow';

interface Props {
  title: string;
  tasks: DailyTask[];
  /** 'overdue' turns the due slot into "N zile" in red, as on the dashboard. */
  tone?: TaskListRowTone;
}

/**
 * A titled group of tasks (TASK-FE-DAILY-005), drawn with the same
 * Linear-style row as the dashboard's "Task-uri & urgențe". Tasks are assumed
 * pre-sorted by project; a hairline separates different projects
 * (FR-DAILY-009).
 */
export function TaskGroup({ title, tasks, tone = 'plain' }: Props) {
  if (tasks.length === 0) return null;

  return (
    <div className="mt-3">
      <h3 className="px-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        {title} <span className="font-normal text-gray-400">({tasks.length})</span>
      </h3>
      <ul className="mt-1 overflow-hidden rounded-md border border-gray-200">
        {tasks.map((task, index) => {
          const prevProject = index > 0 ? getProjectName(tasks[index - 1]) : null;
          const projectChanged = prevProject !== null && getProjectName(task) !== prevProject;
          return (
            <div key={task.id} className={projectChanged ? 'border-t border-gray-200' : ''}>
              <TaskListRow task={dailyTaskRow(task)} tone={tone} newTab />
            </div>
          );
        })}
      </ul>
    </div>
  );
}
